import { TimeUnitsEnum } from "@/services/dictionaries/TimeUnits";

export const getTimeInMinutes = (value: number, unit: TimeUnitsEnum): number => {
    //changing time value to minutes
    switch (unit) {
        case TimeUnitsEnum.Minutes:
            return value;
        case TimeUnitsEnum.Hours:
            return value * 60;
        case TimeUnitsEnum.Days:
            return value * 1440;
        default:
            return 0;
    }
};
